import React, { FC, Suspense } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { TokenErrorStatus } from 'components/organisms/token-error/constant';
import { useLoginWithToken } from 'hooks/use-login-with-token';
import { TokenType } from 'services';

const TokenError = React.lazy(() =>
  import('components/organisms/token-error/token-error').then((d) => ({
    default: d.TokenError,
  })),
);

export const LoginWithToken: FC<
  React.PropsWithChildren<{ token: string; tokenType: TokenType }>
> = ({ token, tokenType }) => {
  const [, isError] = useLoginWithToken(token, tokenType);

  if (isError) {
    return (
      <Suspense fallback={<PageLoading />}>
        <TokenError status={TokenErrorStatus.Invalid} />
      </Suspense>
    );
  }

  return <PageLoading />;
};
